import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt ">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
SENSORY OR INTUITIVE?
</span></div>
                                            <p>Do you feel you are sensory or intuitive? Those who favour a
                                                sensing (S) approach will search for
                                                extra data using their senses to come to a decision, whereas
                                                those who prefer intuition (N) are
                                                more likely to ‘go with their gut’.</p>
                                            <p>It can be helpful to remember that if you are an S then there
                                                may be issues when presenting
                                                information to an N and vice versa. If you are an N
                                                communicating to somebody with an S
                                                preference, then you need to take more time over the
                                                details. If you have an S preference
                                                communicating to an N you need to take more time to think of
                                                the ‘big picture’ first – sell them
                                                the concept and then show the detail. Use the information in
                                                the table below to help guide the
                                                way you present information to S and Ns.</p>

                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink ilead_thought ilead_v_sport_new_task ">
                                                <tbody>
                                                <tr>
                                                    <th width="50%" align="left" valign="center"
                                                        className="green_curve ">Sensing
                                                    </th>
                                                    <th width="50%" align="left" valign="top"
                                                        className="green_curve1">Intuition
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen ">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li className="cntareap"><p>Likes evidence and
                                                                facts</p></li>
                                                        </ul>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <ul className="greenbullet-list uiheading ">
                                                            <li className="cntareap"><p> Likes broad issues
                                                                first</p></li>
                                                        </ul>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen ">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li className="cntareap"><p> Wants practical
                                                                applications shown</p></li>
                                                        </ul>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li className="cntareap"><p> Wants possible
                                                                future challenges discussed</p></li>
                                                        </ul>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen ">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li className="cntareap"><p> Relies on
                                                                experience and anecdotes </p></li>
                                                        </ul>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li className="cntareap"><p> Relies on insights
                                                                and imagination</p></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen ">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li className="cntareap"><p> Likes feasible
                                                                suggestions </p></li>
                                                        </ul>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li className="cntareap"><p> Likes novel
                                                                suggestions</p></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen ">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li className=""><p> Meetings: follows
                                                                agenda </p></li>
                                                        </ul>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li className=""><p> Meetings: uses agenda as
                                                                starting point</p></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <p>In looking at the differences between the styles, S can find
                                                N types impractical and difficult to
                                                follow, while N can find S types pessimistic and overly
                                                focused on details.</p>

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
WRITTEN REPORT EXERCISE
</span></div>
                                            <p>This exercise will help you identify what the crucial points
                                                of your idea are, so that you can convey
                                                them simply, without being hampered by unnecessary
                                                details.</p>
                                            <div className="paraspace"><p>Think about an area of your work
                                                that involves complex ideas. Develop a written report to
                                                explain
                                                this to someone who is new to your area of work, maybe as
                                                part of their induction. Ask someone
                                                with less experience to review it and see if it makes sense
                                                to them. Use the following headings
                                                to help you:</p></div>
                                            <ul className="greenbullet-list uiheading">
                                                <li><p>Label/Name the issue (short heading)</p></li>
                                                <li><p> Define, in no more than 15 words, what it is</p>
                                                </li>
                                                <li><p> Identify the key elements, number them and put them
                                                    in sequence of understanding, i.e.
                                                    which concept does the person need to be familiar with
                                                    in the first instance, then the next
                                                    concept, etc.</p></li>
                                            </ul>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page4')}
                                                     className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}